import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';

export default function CheckoutSuccessPage() {
  const { refreshUser } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    // Refresh user data to get updated tier/credits
    const refresh = async () => {
      try {
        await refreshUser();
      } catch {
        // Ignore errors
      } finally {
        setIsLoading(false);
      }
    };

    // Small delay to allow webhook to process
    setTimeout(refresh, 2000);
  }, [refreshUser]);

  if (isLoading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="text-center">
          <svg className="w-16 h-16 animate-spin mx-auto text-blue-600" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
          </svg>
          <p className="mt-4 text-lg text-slate-600 dark:text-slate-400">
            {t('checkout.processing')}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="max-w-md w-full text-center">
        <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-sm border border-slate-200 dark:border-slate-700 p-8">
          <div className="w-16 h-16 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-8 h-8 text-green-600 dark:text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>

          <h1 className="text-2xl font-bold text-slate-900 dark:text-white mb-2">
            {t('checkout.success')}
          </h1>

          <p className="text-slate-600 dark:text-slate-400 mb-8">
            {t('checkout.thankYou')}
          </p>

          <div className="space-y-3">
            <Link
              to="/usage"
              className="block w-full py-3 px-4 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors"
            >
              {t('checkout.viewUsage')}
            </Link>
            <Link
              to="/analysis"
              className="block w-full py-3 px-4 bg-slate-100 dark:bg-slate-700 hover:bg-slate-200 dark:hover:bg-slate-600 text-slate-900 dark:text-white font-medium rounded-lg transition-colors"
            >
              {t('checkout.startAnalysis')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
